import { Button } from '~/components/ui/button'
import { PAGE } from './use-readings-table'

export interface TablePaginationProps {
    from: number
    to: number
    total: number
    offset: number
    setOffset(offset: number): void
}

/** 측정값 표 하단 페이지네이션(이전/다음). */
export function TablePagination({
    from,
    to,
    total,
    offset,
    setOffset,
}: TablePaginationProps) {
    return (
        <div className='mt-4 flex items-center justify-between gap-2'>
            <span className='text-muted-foreground text-xs'>
                {from}–{to} / {total.toLocaleString()}
            </span>
            <div className='flex gap-2'>
                <Button
                    variant='outline'
                    size='sm'
                    disabled={offset === 0}
                    onClick={() => setOffset(Math.max(0, offset - PAGE))}>
                    이전
                </Button>
                <Button
                    variant='outline'
                    size='sm'
                    disabled={offset + PAGE >= total}
                    onClick={() => setOffset(offset + PAGE)}>
                    다음
                </Button>
            </div>
        </div>
    )
}
